module.exports = {
	name: 'datetime',
	validation(yup) {
		return yup.date();
	}
};
